
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.5 3.5H12a.5.5 0 010-1h11.5a.5.5 0 010 1zm0 18H.5a.5.5 0 010-1h23a.5.5 0 010 1zm0-9H12a.5.5 0 010-1h11.5a.5.5 0 010 1zM5 12.5a.5.5 0 01-.354-.146l-4.5-4.5a.5.5 0 010-.707l4.5-4.5a.5.5 0 01.707.708L1.207 7.5l4.146 4.147A.5.5 0 015 12.5z"}})])
          )
        }
      }
    